export const iframeReset = {
  animation: 'none',
  animationName: 'none',
  backfaceVisibility: 'visible',
  background: 'transparent',
  backgroundAttachment: 'scroll',
  border: '0',
  borderStyle: 'none',
  borderWidth: 'medium',
  borderColor: 'inherit',
  boxShadow: 'none',
  boxSizing: 'content-box',
  color: 'inherit',
  cursor: 'auto',
  display: 'inline',
  height: 'auto',
  left: 'auto',
  margin: '0',
  maxWidth: 'none',
  maxHeight: '100dvh',
  minWidth: 'unset',
  minHeight: 'unset',
  opacity: 1,
  outline: '0',
  outlineColor: 'invert',
  outlineStyle: 'none',
  outlineWidth: 'medium',
  overflow: 'visible',
  overflowX: 'visible',
  overflowY: 'visible',
  padding: '0',
  perspective: 'none',
  position: 'static',
  top: 'auto',
  transform: 'none',
  transition: 'none',
  visibility: 'visible',
  whiteSpace: 'normal',
  widows: 0,
  width: 'auto',
  zIndex: 'auto',
};

export const mainContainerStyles = {
  position: 'fixed',
  bottom: '0px',
  right: '0px',
  width: '100vw',
  height: '0px',
  zIndex: '100000',
};

export const portalFrameStyles = {
  margin: '0',
  height: '100%',
  display: 'grid',
  justifyContent: 'center',
  alignContent: 'center',
  alignItems: 'center',
  justifyItems: 'center',
};

export const widgetFrameStyles = {
  margin: 0,
  width: '100%',
  height: '100%',
  overflow: 'hidden',
};
